import SiteMap from './siteMap';
import template from './siteModalMap.component.html';

/* @ngInject */
function SiteModalMapController(
  $scope,
  $document,
  MapService
) {
  const vm = this;
  // can set coords/path into this on save from parent
  const siteMap = new SiteMap(MapService, setPosition, true /* if polygon already there false */);

  vm.$onDestroy = () => {
    siteMap.unlisten();
  };

  vm.$postLink = () => {
    // Map for the Location of the new site
    const { siteLat: latitude, siteLng: longitude, siteBorder: border, siteEquipment: equipment } = vm;
    siteMap.drawMap(
      { latitude, longitude, border },
      equipment,
      $document[0].getElementById('site-loc'),
      'edit-site-modals',
    );
  };

  function setPosition(lat, lng, border) {
    $scope.$apply(() => {
      vm.siteLat = lat;
      vm.siteLng = lng;
      vm.siteBorder = border;
    });
  }

}


export default {
  name: 'siteModalMap',
  template,
  controller: SiteModalMapController,
  bindings: {
    siteLat: '=',
    siteLng: '=',
    siteBorder: '=',
    siteEquipment: '='
  }
};
